export const getFormattedDate = (
  date: Date | null,
  format: string = 'dd-mm-yyyy',
  seperator: string = '-',
) => {
  if (date) {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const year = date.getFullYear();

    const formatterMaper = {
      dd: day,
      mm: month,
      yyyy: year,
    };

    const formatterSegment = format.split('-');
    let formattedDateArray = formatterSegment.map(
      (segment: string) => formatterMaper[segment.toLowerCase()],
    );

    return formattedDateArray.join(seperator);
  }
  return null;
};
